/**
 * OpsSituacaoWidget — Contagem de OPs por situacao.
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarOrdensProducao } from "../../../services/producao";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "ops_situacao",
  label: "OPs por situação",
  descricao: "Contagem agregada de Ordens de Produção por situação.",
  categoria: "Produção",
  permissoes: ["ordem_producao:view"],
  tamanho_default: "M",
  essencial: false,
};

async function contar(request, situacao) {
  const payload = await listarOrdensProducao(request, { situacao, pageSize: 1 });
  return Array.isArray(payload) ? payload.length : (payload?.count ?? (payload?.results || []).length);
}

export async function fetchData(request) {
  const [liberada, em_producao, concluida] = await Promise.all([
    contar(request, "LIBERADA"),
    contar(request, "EM_PRODUCAO"),
    contar(request, "CONCLUIDA"),
  ]);
  return { liberada, em_producao, concluida };
}

export function Widget({ dados }) {
  const l = dados?.liberada ?? 0;
  const p = dados?.em_producao ?? 0;
  const c = dados?.concluida ?? 0;
  const total = l + p + c;
  return (
    <>
      <CardBody>
        <KpiValor>{p}</KpiValor>
        <KpiSub>OPs em produção agora</KpiSub>
        <div style={{ marginTop: 6, fontSize: "0.82rem", display: "flex", gap: 12 }}>
          <span>Liberadas: <strong>{l}</strong></span>
          <span>Em prod: <strong>{p}</strong></span>
          <span>Concluidas: <strong>{c}</strong></span>
        </div>
        {total === 0 && <KpiSub>Nenhuma OP ativa.</KpiSub>}
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/producao">Ver produção</LinkLight>
      </CardFooter>
    </>
  );
}
